//#region Util Imports

import * as $ from 'jquery'

//#endregion

import { IReferenceType, IOpChangeState, IJsonSerializable } from '../util/interfaces'
import { DataProvider } from '../../helpers/data-provider'
import { Enums } from '../common/enums'

export class OpLanguage implements IReferenceType, IOpChangeState, IJsonSerializable {
    public idLanguage: number
    public name: string

    constructor(opObj: any) {
        this.fromJSON(opObj)
    }

    //IOpChangeState implementation
    public opState: Enums.OpChangeState
    //IOpChangeState implementation end
    //IReferenceType implementation
    public getReferenceType(): Enums.ReferenceType {
        return Enums.ReferenceType.IdLanguage
    }
    public getReferenceKey(): number {
        return this.idLanguage
    }
    public getReferenceValue(): any {
        return this
    }
    //IReferenceType implementation end


    public fromJSON(opObj: any, compressed: boolean = false): void {
        if (opObj) {
            if (compressed || (opObj && opObj.__IC && opObj.__IC == 1)) {
                this.idLanguage = opObj.I
                this.name = opObj.N
                this.opState = opObj.O
            } else {
                this.idLanguage = opObj.ID_LANGUAGE
                this.name = opObj.NAME
                this.opState = opObj.OpState
            }
        }
    }

    public toJSON(compressed: boolean = false): any {
        if (compressed) {
            return {
                I: this.idLanguage,
                N: this.name,
                O: this.opState,
                __IC: 1
            }
        } else {
            return {
                ID_LANGUAGE: this.idLanguage,
                NAME: this.name,
                OpState: this.opState
            }
        }
    }

    public toString() {
        return this.name
    }

    public static loadNavigationProperties(dataProvider: DataProvider, list: OpLanguage[]): JQueryPromise<OpLanguage[]> {
        var defered = $.Deferred<OpLanguage[]>()

        defered.resolve(list)

        return defered.promise()
    }
}